import { findKey } from 'lodash';

/**
 * Get child options for a given root value with case-insensitive fallback.
 * This is needed to handle legacy data where case might not match exactly.
 *
 * @param {Object} options - The options object with root keys
 * @param {string} rootValue - The root value to look up
 * @returns {Array|undefined} The child options array or undefined if not found
 */
export const getChildOptions = (options, rootValue) => {
  // Try exact match first
  if (options[rootValue]) {
    return options[rootValue];
  }

  // Fallback: case-insensitive match for legacy data
  if (rootValue && typeof rootValue === 'string') {
    const matchingKey = findKey(
      options,
      (_, key) => key.toLowerCase() === rootValue.toLowerCase(),
    );
    return matchingKey ? options[matchingKey] : undefined;
  }

  return undefined;
};
